import './home.scss';

import saveAs from "file-saver";

const $form = $('form#home-form'), url = 'https://script.google.com/macros/s/AKfycbyH3aFXgyXm6t6274mWIaHZr31qqP2yVJqiaakZf8X2RYE8DJg/exec';
$form.validate({
  errorPlacement: function(error, element) {},
});

const $contactForm = $('form#contact-form');
$contactForm.validate({
  errorPlacement: function(error, element) {},
});

function getFormData($form) {
  const unIndexed_array = $form.serializeArray();
  const indexed_array = {};

  $.map(unIndexed_array, function(n, i){
    indexed_array[n['name']] = n['value'];
  });

  return indexed_array;
}

$('#submit-home-form').click(function(e) {
  e.preventDefault();
  if ($form.valid()) {
    $("#submit-home-form").text('Cargando...');
    $.ajax({
      url: url,
      method: "GET",
      dataType: "json",
      data: {...getFormData($form), Date: new Date()},
      success: function (res) {
        saveAs("../assets/files/Pakke-Basicos.pdf", "Pakke - Básicos.pdf");
        $('#download-thanks').appendTo('body').modal({
          fadeDuration: 250
        });
        $form[0].reset();
        $("#submit-home-form").text('Descargar');
      }
    })
  } else {
    var $inputs = $('#home-form :input');
    $inputs.each(function() {
      var input = $(this);
      if (!input.valid()) {
        input.addClass('error');
      } else {
        input.removeClass('error');
      }
    });
  }
});

$('#submit-contact-form').click(function(e) {
  e.preventDefault();
  if ($contactForm.valid()) {
    $("#submit-contact-form").text('Cargando...');
    $.ajax({
      url: url,
      method: "GET",
      dataType: "json",
      data: {...getFormData($contactForm), Date: new Date()},
      success: function (res) {
        $('#contact-thanks').appendTo('body').modal({
          fadeDuration: 250
        });
        $contactForm[0].reset();
        $("#submit-contact-form").text('Descargar');
      }
    })
  } else {
    var $inputs = $('#contact-form :input');
    $inputs.each(function() {
      var input = $(this);
      if (!input.valid()) {
        input.addClass('error');
      } else {
        input.removeClass('error');
      }
    });
  }
});

$(document).ready(function() {

});
